import { ChangeDetectionStrategy, Component, DestroyRef, effect, inject, input, OnInit, output } from '@angular/core';
import { debounceTime, tap } from 'rxjs';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

interface IPhoenixTableDollarAmountForm {
  dollarAmount: FormControl<string>;
}

@Component({
  selector: 'app-phoenix-table-dollar-amount-input',
  templateUrl: './phoenix-table-dollar-amount-input.component.html',
  styleUrl: './phoenix-table-dollar-amount-input.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PhoenixTableDollarAmountInputComponent implements OnInit {
  id_ = input.required<string>();
  dollarAmountChanged = output<string>();

  private _destroyRef = inject(DestroyRef);
  private _fb = inject(FormBuilder);

  protected form: FormGroup<IPhoenixTableDollarAmountForm>;
  
  constructor() {
    effect(() => {
      // The phoenix table utilizes virtual scrolling, which caches instances of components like this one.
      // This caching means the component may be reused across different rows or contexts, potentially with a different ID.
      // To ensure the component behaves correctly, we reset the form whenever the ID changes, avoiding stale or incorrect data.
      this.id_();
      
      if (this.form?.get('dollarAmount')) {
        this.form.get('dollarAmount').setValue('', { emitEvent: false });
      }
    });
  }

  ngOnInit(): void {
    this.form = this._fb.group({
      dollarAmount: ''
    });    

    this.form.get('dollarAmount').valueChanges
      .pipe(
        debounceTime(300),
        tap((val) => this.dollarAmountChanged.emit(val)),
        takeUntilDestroyed(this._destroyRef)
      )
      .subscribe();
  }
}
